import React, { useState } from "react";
import styles from "./Announcement.module.css";
import Dropdown from "../../components/Dropdown/Dropdown";
import AnnouncementsCard from "../../components/AnnouncementsCard/AnnouncementsCard";
import IconAndName from "../../components/IconAndName/IconAndName";
import { IoAddCircleOutline } from "react-icons/io5";
import { useDispatch } from "react-redux";
import { openModal } from "../../redux/slices/modalSlice";
import CopyRight from "../../components/CopyRight/CopyRight";

const Announcement = () => {
  const [filters, setFilters] = useState({});
  const [announcements, setAnnouncements] = useState([
    {
      id: 1,
      image:
        "https://img.freepik.com/free-photo/front-view-kids-reading-book_23-2150877935.jpg",
      description:
        "Your Kids are playing in the ground. And This activity is led by PT sir and Class teacher Darshan. The kids played approximately for an hour and sanitized",
      tagged: ["Staff 1", "Staff 2"],
      time: "12:00 PM",
      date: "3rd June 2025",
    },
    {
      id: 2,
      image:
        "https://img.freepik.com/free-photo/front-view-kids-reading-book_23-2150877935.jpg",
      description:
        "Your Kids are playing in the ground. And This activity is led by PT sir and Class teacher Darshan. The kids played approximately for an hour and sanitized",
      tagged: ["Staff 1", "Staff 2", "Staff 3"],
      time: "1:30 PM",
      date: "3rd June 2025",
    },
    {
      id: 2,
      image:
        "https://img.freepik.com/free-photo/front-view-kids-reading-book_23-2150877935.jpg",
      description:
        "Your Kids are playing in the ground. And This activity is led by PT sir and Class teacher Darshan. The kids played approximately for an hour and sanitized",
      tagged: ["Staff 1", "Staff 2", "Staff 3"],
      time: "1:30 PM",
      date: "3rd June 2025",
    },
    {
      id: 2,
      image:
        "https://img.freepik.com/free-photo/front-view-kids-reading-book_23-2150877935.jpg",
      description:
        "Your Kids are playing in the ground. And This activity is led by PT sir and Class teacher Darshan. The kids played approximately for an hour and sanitized",
      tagged: ["Staff 1", "Staff 2", "Staff 3"],
      time: "1:30 PM",
      date: "3rd June 2025",
    },
  ]);
  const dispatch=useDispatch();
  const handleFilterChange = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
    console.log("Filter Changed:", { [key]: value });
  };

  const handleRemoveTagged = (id, name) => {
    setAnnouncements((prev) =>
      prev.map((item) =>
        item.id === id
          ? {
              ...item,
              tagged: item.tagged.filter((t) => t !== name),
            }
          : item
      )
    );
  };
  const handleAddClick = () => dispatch(openModal("staffAnnouncement"));

  const handleActionSelect = (action, id) => {
    console.log(`Action '${action}' on announcement ID ${id}`);
    // You can dispatch modal or deletion logic here
  };

  return (
    <>
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.header}>
          <IconAndName
            icon={<IoAddCircleOutline size={16} />}
            title="Post Announcement"
            onClick={handleAddClick}
            bgColor="Primary_Color"
          />
        </div>
        <div className={styles.toolbarWrapper}>
          <Dropdown
            label="Room"
            options={["Room A", "Room B"]}
            onChange={(val) => handleFilterChange("room", val)}
          />
          <Dropdown
            label="Program"
            options={["KG", "Grade 1"]}
            onChange={(val) => handleFilterChange("program", val)}
          />
          <Dropdown
            label="Label"
            options={["General", "Urgent"]}
            onChange={(val) => handleFilterChange("label", val)}
          />
          <Dropdown
            label="Unapproved"
            options={["Yes", "No"]}
            onChange={(val) => handleFilterChange("unapproved", val)}
          />
          <Dropdown
            label="Staff only"
            options={["Yes", "No"]}
            onChange={(val) => handleFilterChange("staffOnly", val)}
          />
          <Dropdown
            label="With attachments"
            options={["Yes", "No"]}
            onChange={(val) => handleFilterChange("attachments", val)}
          />
        </div>

        <div className={styles.pageWrapper}>
          <div className={styles.grid}>
            {announcements.map((item) => (
              <AnnouncementsCard
                key={item.id}
                id={item.id}
                image={item.image}
                description={item.description}
                tagged={item.tagged}
                time={item.time}
                date={item.date}
                onActionSelect={handleActionSelect}
                onRemoveTagged={handleRemoveTagged}
              />
            ))}
          </div>
        </div>
      </div>
      
    </div>
    <CopyRight/>
    </>
  );
};

export default Announcement;
